export enum DemoTheme {
  ELearning = 'elearning',
  XYZbets = 'xyz_bets',
}

export const FPJS_API_KEY = process.env.REACT_APP_FPJS_PUBLIC_API_KEY ?? 'test_public_key'
export const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:3002'
export const DEMO_THEME = process.env.REACT_APP_DEMO_THEME ?? DemoTheme.ELearning
export const VISO_INTEGRATION_ENABLED = process.env.REACT_APP_VISO_INTEGRATION_ENABLED === 'true'
